import React from 'react';

import classNames from "classnames";
import {GameCenterHeaderModuleProps} from "../../../models/game-center-header-module.props";
import styles from "../../../styles/game-center-header-competitor.module.scss"
import {GameCompetitorViewModel} from "../../../../../../../domain/partial-game/models/game-competitor/game-competitor-view-model";

export class GameCenterHeaderDetailsCompetitorSeasonRecordProps extends GameCenterHeaderModuleProps {
  competitor: GameCompetitorViewModel;
}

export const GameCenterHeaderDetailsCompetitorSeasonRecord = ({competitor}: GameCenterHeaderDetailsCompetitorSeasonRecordProps) => {
  return (
    competitor.isShowRecord && <div className={classNames(styles.season_record)}>
      {competitor?.recordLabel}
    </div>
  );
};